export const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

export const endPoints = {
  createFaceLivenessSession: "age-estimation/verification",
  startVerificationSession: "verification",
  verifyFace: "verify-process",
  trackPageVisiting: "verification",
};

export const constants = {};
